import { Paper, Tooltip, Typography, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { NavItem } from "../interfaces/RequestBase";

import { Email, Folder, NoteAlt } from "@mui/icons-material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GroupIcon from "@mui/icons-material/Group";
import GroupsIcon from "@mui/icons-material/Groups";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import QuizIcon from "@mui/icons-material/Quiz";
import ReceiptIcon from "@mui/icons-material/Receipt";
import WorkIcon from "@mui/icons-material/Work";
interface IProps {
	isOpen: boolean;
}

const NavRow = (props: NavItem) => {
	const isActive = useLocation().pathname === props.url;
	const theme = useTheme();
	return (
		<Tooltip title={props.title} placement="right">
			<Link to={props.url}>
				<div
					className="flex items-center hover:bg-slate-200 cursor-pointer select-none max-h-12"
					style={isActive ? { background: theme.palette.primary.main } : {}}
				>
					<div className="w-12">{props.icon}</div>
					<Typography className="ml-3">{props.title}</Typography>
				</div>
			</Link>
		</Tooltip>
	);
};

const NavBar = (props: IProps) => {
	return (
		<div className="w-9 sticky self-start top-0 z-50">
			<Paper
				className="overflow-hidden transition-all !rounded-none"
				style={{ width: props.isOpen ? "160px" : "36px", transition: "0.3s" }}
			>
				<NavRow
					icon={<ReceiptIcon fontSize="large" />}
					title={"Заявки"}
					url={"/requests"}
				/>
				<NavRow
					icon={<GroupsIcon fontSize="large" />}
					title={"Кандидаты"}
					url={"/candidates"}
				/>
				<NavRow
					icon={<WorkIcon fontSize="large" />}
					title={"Вакансии"}
					url={"/vacancies"}
				/>
				<NavRow
					icon={<NoteAlt fontSize="large" />}
					title={"Интервью"}
					url={"/interviews"}
				/>
				<NavRow
					icon={<AssignmentIcon fontSize="large" />}
					title={"Задачи"}
					url={"/tasks"}
				/>
				{/* <NavRow
					icon={<QuizIcon fontSize="large" />}
					title={"Тесты"}
					url={"/tests"}
				/> */}
				<NavRow
					icon={<Folder fontSize="large" />}
					title={"Шаблоны"}
					url={"/templates"}
				/>
				<NavRow
					icon={<Email fontSize="large" />}
					title={"Рассылка"}
					url={"/letters"}
				/>
				<NavRow
					icon={<LocationCityIcon fontSize="large" />}
					title={"Места"}
					url={"/regions"}
				/>
				<NavRow
					icon={<GroupIcon fontSize="large" />}
					title={"Менеджеры"}
					url={"/managers"}
				/>
			</Paper>
		</div>
	);
};

export default NavBar;
